import { SignatureBox } from './SignatureBox';
import { Button } from './buttons/Button';
import { FileName, FileTypes } from '../types/Files/FileTypes';
import { SignatureAreaProps } from '../types/Signatures/SignatureAreaProps';
import { useUpdateChartSection } from '../hooks/useUpdateChartSection';
import { cloneConsentSignature } from '../utilities/cloneConsentSignature';
import { useHandleFileUploadSuccess } from '../hooks/useHandleFileUploadSuccess';
import * as Sentry from '@sentry/browser';
import { ButtonGreen } from './buttons';

export const SignatureArea = (props: SignatureAreaProps) => {
  const { mutate } = useUpdateChartSection();
  const { updateFirestore } = useHandleFileUploadSuccess();

  const handleRemoveSignature = () => {
    if (props.docToUpdate === 'HIPAA_AUTH') {
      mutate(
        {
          patientId: props.patientId,
          docData: {
            HIPAA_AUTH: {
              signature1DataURI: '',
              firstName: props.data.HIPAA_AUTH.firstName || '',
              lastName: props.data.HIPAA_AUTH.lastName || '',
              exceptions: props.data.HIPAA_AUTH.exceptions || '',
              middleName: props.data.HIPAA_AUTH.middleName || '',
            },
          },
        },
        {
          onSuccess: () => {
            // alert("Successfully updated document");
          },
          onError: (error) => {
            Sentry.captureException(error);
            alert(`Error updating document: ${error.message}`); // TELL THE USER
            console.error(error); // GET THE STACKTRACE
          },
        },
      );
    }
    if (props.docToUpdate === 'PATIENT_SIGNATURE') {
      mutate(
        {
          patientId: props.patientId,
          docData: {
            PATIENT_SIGNATURE: {
              signature1DataURI: '',
            },
          },
        },
        {
          onSuccess: () => {
            // alert("Successfully updated document");
          },
          onError: (error) => {
            Sentry.captureException(error);
            alert(`Error updating document: ${error.message}`); // TELL THE USER
            console.error(error); // GET THE STACKTRACE
          },
        },
      );
    }
    if (props.docToUpdate === 'CONSENT_FOR_CARE') {
      mutate(
        {
          patientId: props.patientId,
          docData: {
            CONSENT_FOR_CARE: {
              signature1DataURI: '',
            },
          },
        },
        {
          onSuccess: () => {
            // alert("Successfully updated document");
          },
          onError: (error) => {
            Sentry.captureException(error);
            alert(`Error updating document: ${error.message}`); // TELL THE USER
            console.error(error); // GET THE STACKTRACE
          },
        },
      );
    }
    if (props.docToUpdate === 'ABN_INFO') {
      mutate(
        {
          patientId: props.patientId,
          docData: {
            ABN_INFO: {
              additionalInfo: props.data.ABN_INFO.additionalInfo || '',
              medicareABNChoice: props.data.ABN_INFO.medicareABNChoice || '',
              nonMedicareABNChoice: props.data.ABN_INFO.nonMedicareABNChoice || '',
              returning: true,
              signature1DataURI: '',
            },
          },
        },
        {
          onSuccess: () => {
            // alert("Successfully updated document");
          },
          onError: (error) => {
            Sentry.captureException(error);
            alert(`Error updating document: ${error.message}`); // TELL THE USER
            console.error(error); // GET THE STACKTRACE
          },
        },
      );
    }
    if (props.docToUpdate === 'ASSIGNMENT_OF_BENEFITS') {
      mutate(
        {
          patientId: props.patientId,
          docData: {
            ASSIGNMENT_OF_BENEFITS: {
              reason: props.data.ASSIGNMENT_OF_BENEFITS.reason || '',
              signature1DataURI:
                props.type === FileTypes.aobSig1
                  ? ''
                  : (props.data.ASSIGNMENT_OF_BENEFITS && props.data.ASSIGNMENT_OF_BENEFITS.signature1DataURI) || '',
              signature2DataURI:
                props.type === FileTypes.aobSig2
                  ? ''
                  : (props.data.ASSIGNMENT_OF_BENEFITS && props.data.ASSIGNMENT_OF_BENEFITS.signature2DataURI) || '',
            },
          },
        },
        {
          onSuccess: () => {
            // alert("Successfully updated document");
          },
          onError: (error) => {
            Sentry.captureException(error);
            alert(`Error updating document: ${error.message}`); // TELL THE USER
            console.error(error); // GET THE STACKTRACE
          },
        },
      );
    }
  };

  if (
    props &&
    (props.docToUpdate === 'HIPAA_AUTH' ||
      props.docToUpdate === 'PATIENT_SIGNATURE' ||
      props.docToUpdate === 'CONSENT_FOR_CARE' ||
      props.docToUpdate === 'ABN_INFO' ||
      props.docToUpdate === 'ASSIGNMENT_OF_BENEFITS')
  ) {
    return (
      <div>
        {/* @ts-expect-error: This should be an issue as props.type is set when docToUpdate is set. BE SURE TO ONLY REQUEST IMAGES FOR DATA URLS THAT EXIST ON THE DOC BEING READ */}
        {props.data[props.docToUpdate] && props.data[props.docToUpdate][FileName[props.type]].length > 0 ? (
          <div className="" id={props.elementId + '-container'}>
            <p className="mt-4 text-lg font-bold">Signature on file:</p>
            <img
              // @ts-expect-error: see above.
              src={props.data[props.docToUpdate][FileName[props.type]]}
              alt="Patient Final Signature"
              className="w-1/2"
              id={props.elementId + 'image'}
            />
            <Button
              type="button"
              id={props.elementId + 'resign'}
              textContent="Re-sign"
              onClick={() => {
                props.setIsSigning({ ...props.isSigning, [props.sigName]: true });
                handleRemoveSignature();
              }}
            />
          </div>
        ) : props.isSigning[props.sigName] ? (
          <SignatureBox
            elementId={props.elementId + 'sig-box'}
            type={FileTypes[props.type]}
            bucket="patient"
            path={props.cloudStoragePath}
            docToUpdate={props.docToUpdate}
            patientId={props.patientId}
            hideSigBox={() => props.setIsSigning({ ...props.isSigning, [props.sigName]: false })}
          />
        ) : (
          <div id={props.elementId + 'container'} className="flex flex-row items-center">
            <Button
              type="button"
              id="patient-final-sig-sign-now"
              textContent="Sign Now"
              onClick={() => props.setIsSigning({ ...props.isSigning, [props.sigName]: true })}
            />
            {props.canComeFromClone && (
              <div className="ml-4">
                <ButtonGreen
                  type="button"
                  id="patient-final-sig-clone"
                  textContent="Apply Existing"
                  onClick={() => {
                    cloneConsentSignature({
                      bucket: 'patient',
                      patientId: props.patientId,
                      type: props.type,
                      docToUpdate: props.docToUpdate,
                      originStoragePath:
                        props.data.CONSENT_FOR_CARE && props.data.CONSENT_FOR_CARE.signature1DataURI
                          ? props.data.CONSENT_FOR_CARE.signature1DataURI
                          : '',
                      destinationStoragePath: props.cloudStoragePath,
                      updateFirestore,
                    });
                  }}
                />
              </div>
            )}
          </div>
        )}
      </div>
    );
  } else {
    return <>Cannot load signature. There are no signatures to reference</>;
  }
};
